
















































































































































































































import { Component, Vue } from "vue-property-decorator";
import alatReuseStore from "@/store/modules/AlatReuseStore";
import { KATEGORI_ALAT_REUSE, METODE_STERILISASI } from "@/constants/alatReuseOptions";
import { MasterAlatReuse } from "@/types/alat_reuse";

@Component
export default class MasterAlatReusePage extends Vue {
  filter: any = { search: "", kategori: null, aktif: "" };
  dialog = false;
  deleteDialog = false;
  saving = false;
  editingId: number | null = null;
  toDelete: MasterAlatReuse | null = null;
  errors: Record<string, string[]> = {};

  form: any = this.emptyForm();

  kategoriOptions = KATEGORI_ALAT_REUSE;
  metodeSterilisasiOptions = METODE_STERILISASI;

  headers = [
    { text: "Kode", value: "kode_alat", width: 100 },
    { text: "Nama Alat", value: "nama_alat" },
    { text: "Kategori", value: "kategori", width: 130 },
    { text: "Merk", value: "merk", width: 130 },
    { text: "Max", value: "max_penggunaan", width: 80, align: "center" },
    { text: "Terpakai", value: "penggunaan_count", width: 100, align: "center" },
    { text: "Steril", value: "metode_sterilisasi", width: 120 },
    { text: "Status", value: "aktif", width: 100 },
    { text: "", value: "actions", sortable: false, width: 90 }
  ];

  get loading() { return alatReuseStore.loading; }
  get masterList() { return alatReuseStore.masterList; }

  emptyForm() {
    return {
      kode_alat: "",
      nama_alat: "",
      kategori: null,
      merk: "",
      max_penggunaan: 1,
      metode_sterilisasi: null,
      catatan_reprocessing: "",
      aktif: true
    };
  }

  async mounted() {
    await this.loadData();
  }

  async loadData() {
    await alatReuseStore.loadMaster({
      search: this.filter.search || undefined,
      kategori: this.filter.kategori || undefined,
      aktif: this.filter.aktif === "" ? undefined : this.filter.aktif
    });
  }

  openCreate() {
    this.editingId = null;
    this.form = this.emptyForm();
    this.errors = {};
    this.dialog = true;
  }

  openEdit(item: MasterAlatReuse) {
    this.editingId = item.id;
    this.form = {
      kode_alat: item.kode_alat,
      nama_alat: item.nama_alat,
      kategori: item.kategori || null,
      merk: item.merk || "",
      max_penggunaan: item.max_penggunaan,
      metode_sterilisasi: item.metode_sterilisasi || null,
      catatan_reprocessing: item.catatan_reprocessing || "",
      aktif: item.aktif
    };
    this.errors = {};
    this.dialog = true;
  }

  async save() {
    this.saving = true;
    this.errors = {};
    try {
      if (this.editingId) {
        await alatReuseStore.updateMaster({ id: this.editingId, data: this.form });
      } else {
        await alatReuseStore.createMaster(this.form);
      }
      this.dialog = false;
      await this.loadData();
    } catch (e) {
      const err = e as any;
      if (err && err.response && err.response.data && err.response.data.errors) {
        this.errors = err.response.data.errors;
      }
    } finally {
      this.saving = false;
    }
  }

  confirmDelete(item: MasterAlatReuse) {
    this.toDelete = item;
    this.deleteDialog = true;
  }

  async doDelete() {
    if (!this.toDelete) return;
    this.saving = true;
    try {
      await alatReuseStore.deleteMaster(this.toDelete.id);
      this.deleteDialog = false;
      this.toDelete = null;
      await this.loadData();
    } finally {
      this.saving = false;
    }
  }

  usageLabelClass(item: MasterAlatReuse) {
    const count = item.penggunaan_count || 0;
    const max = item.max_penggunaan;
    if (count >= max) return "red--text font-weight-bold";
    if (count >= max * 0.8) return "orange--text font-weight-bold";
    return "";
  }
}
